module.exports = __webpack_public_path__ + "media/images/emoticons/parking-21f6e7e775dae4247d106cb5fda0b7b5.gif";